import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Splash = () => (
  <div className="cyber-bg min-h-screen grid place-items-center">
    <div className="font-mono-display text-zinc-400 tracking-widest uppercase text-sm animate-pulse">
      Loading vault...
    </div>
  </div>
);

export const RequireAuth = ({ children }) => {
  const { isAuthed, loading } = useAuth();
  if (loading) return <Splash />;
  if (!isAuthed) return <Navigate to="/auth/login" replace />;
  return children;
};

export const RequireGuest = ({ children }) => {
  const { isAuthed, loading } = useAuth();
  if (loading) return <Splash />;
  if (isAuthed) return <Navigate to="/dashboard" replace />;
  return children;
};

export const RequireAdmin = ({ children }) => {
  const { isAdmin, loading } = useAuth();
  if (loading) return <Splash />;
  if (!isAdmin) return <Navigate to="/secure-portal-9x47" replace />;
  return children;
};
